<div class="device-mobile-data">
  <div class="form-group">
    <label class="field-layout__header">Brand</label>
    <div class="field-value">{{ brand }}</div>
  </div>
  <div class="form-group mt-6">
    <label class="field-layout__header">Model</label>
    <div class="field-value">{{ phoneModel }}</div>
  </div>
  <div class="form-group mt-6">
    <label class="field-layout__header">IMEI</label>
    <div class="field-value">{{ imei }}</div>
  </div>
</div>
